import {
  getProjectIdFromMaterialRow,
  type ProjectNameSource,
} from './analysisMaterialProjectContext';

/** When restrictToUserAccess is true, return assigned project IDs; otherwise null (no filter). */
export function buildAccessibleProjectIdSet(
  projectList: Array<{ projectId?: string | number | null }>,
  restrictToUserAccess: boolean
): Set<string> | null {
  if (!restrictToUserAccess) return null;
  return new Set(
    projectList
      .map((p) => p.projectId)
      .filter((id) => id != null && id !== '')
      .map((id) => String(id))
  );
}

/**
 * Role "user" Pipe Inventory: keep warehouse/unscoped rows; drop rows linked to
 * projects outside the assigned project set.
 */
export function filterMaterialsByAccessibleProjects<T extends Record<string, unknown>>(
  materials: T[],
  accessibleProjectIds: Set<string> | null,
  projectList: ProjectNameSource[] = []
): T[] {
  if (!accessibleProjectIds) return materials;

  return materials.filter((row) => {
    const projectId = getProjectIdFromMaterialRow(row, projectList);
    if (!projectId) return true;
    return accessibleProjectIds.has(String(projectId));
  });
}
